module.exports = __webpack_public_path__ + "img/united-kingdom.8a347efe.svg";